import { Component, PropSync, Vue } from "vue-property-decorator";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Reconciliation } from "@/constant";

@Component<LBdetail>({
  components: {},
})
export default class LBdetail extends Vue {
  // prop in
  @PropSync("detailTitle", { type: Object })
  syncedDetailTitle!: object;

  private transactionMap = Reconciliation.TransactionMap;

  // @PropSync("detail", { type: TCBReceiptApi.Protobuf.ReimbursementInfo })
  // syncedDetail!: TCBReceiptApi.Protobuf.ReimbursementInfo;
  
  // 來源不一定樣 如何兼容來自請款撥款的型別
  @PropSync("detail")
  syncedDetail!: Record<string, any>;

  @PropSync("detailType")
  syncedDetailType!: number;

  // event out
  private close() {
    this.$emit("closeLBdetail"); // 觸發的事件名稱
  }
}
